<template>
  <div class="error-modal-modal">
    <CustomModal :show="display"
                 @close="onClose">
      <template #header>
        <slot name="heading">
          <h1 class="custom-modal__heading">
            {{ heading }}
          </h1>
        </slot>
      </template>

      <div class="error-modal-modal__body">
        <slot name="errorTitle">
          <h3>{{ title }}</h3>
        </slot>
        <slot name="errorMessage">
          <span ref="error-message"></span>
        </slot>
      </div>

      <template #footer>
        <div class="d-flex ml-auto justify-content-between">
          <button
            class="btn btn-accent-6 btn-rounded"
            aria-label="Acknowledge and close"
            @click="onClose">
            Ok
          </button>
        </div>
      </template>
    </CustomModal>
  </div>
</template>

<script>
import CustomModal from "~/Components/CustomModal.vue";

export default {
  name: "ErrorModal",
  components: {
    CustomModal
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: "Unexpected error"
    },
    title: {
      type: String,
      default: "Error"
    },
    errorMessage: {
      type: String,
      default: `<p>Something has gone wrong whilst trying to process your request. Please try again later.</p>
         <p>If this issue persists, please contact us.</p>`
    }
  },
  data: () => ( {
    display: false
  } ),
  watch: {
    show ( val ) {
      this.display = val;
    },
    errorMessage ( val ) {
      this.setErrorMessageHtml( val );
    }
  },
  created () {
    this.display = this.show;
  },
  mounted () {
    this.setErrorMessageHtml( this.errorMessage );
  },
  methods: {
    onClose () {
      this.display = false;
      this.$emit( "close" );
    },
    setErrorMessageHtml ( value ) {
      this.$refs["error-message"].innerHTML = value;
    }
  }
};
</script>

<style lang="less" scoped></style>
